/*
 mixins

 This file adds helpful mixins to the Lodash library.

 */

import _ from 'lodash';

//Return a defaultValue if value is null or undefined
_.mixin({
  defaultIfNullOrUndefined: function (value, defaultValue) {
    return _.isNull(value) || _.isUndefined(value) ? defaultValue : value;
  }
});

//Determine if value is null or undefined
_.mixin({
  isNullOrUndefined: function (value) {
    return _.isNull(value) || _.isUndefined(value);
  }
});

//Return a new object after applying a mapper function recursively to all properties.
_.mixin({
  mapObjectDeep: function (obj, mapper) {
    return mapper(_.mapValues(obj, function (o) {      
      return _.isObject(o) ? _.mapObjectDeep(o, mapper) : o;
    }));
  }
});

//Return a new object with all properties converted to camelCase instead of TitleCase or snake_case.
_.mixin({
  camelCaseObject: function (obj) {

    var mapper = function (o) {
      return _.mapKeys(o, function (val, key) { return _.camelCase(key); })
    }

    return _.mapObjectDeep(obj, mapper);
  }
});

//Return a collection of objects with all properties converted to camelCase instead of TitleCase or snake_case.
_.mixin({
  mapCamelCase: function (col) {
    return _.map(col, function (o) {
      return _.camelCaseObject(o);
    })
  }
});

//Return the object with all properties converted to C-Sharp case instead of camelCase or snake_case.
_.mixin({
  mapToCSharpCase: function (obj) {

    //Object mapper function
    var mapper = function (o) {
      return _.mapKeys(o, function (val, key) {
        return toCSharpCase(key);
      })
    }

    //Deep mapping function
    var mapObjectDeep = function (objToMap, mapper) {

      //Track which properties are arrays.
      //After mapping, we need to update these values one more time.
      var arrayKeys = _.filter(_.keys(objToMap), function (key) {
        return _.isArray(objToMap[key]);
      });

      //Map object using mapper function
      var objMapped = mapper(_.mapValues(objToMap, function (o) {
        return _.isObject(o) ? _.mapObjectDeep(o, mapper) : o;
      }));

      //Go back and update all array properties.
      //This is necessary to allow our arrays to be stringify-able.
      _.forEach(arrayKeys, function (key) {
        key = toCSharpCase(key);
        objMapped[key] = _.toArray(objMapped[key]);
      });

      return objMapped;
    }

    //Function to convert string key to CSharp case
    var toCSharpCase = function (val) {

      //Uppercase Id fields
      if (_.endsWith(val, 'ID')) {
        val = val.substring(0, val.length - 2) + 'Id';
      }
      if (_.toLower(val) == 'id') {
        val = 'Id';
      }

      //Uppercase first letter 
      return _.upperFirst(val);
    }

    //Handle the mapping here...
    if (_.isArray(obj)) {
      return _.map(obj, function (o) {
        return mapObjectDeep(o, mapper);
      })
    }
    else
    {
      return mapObjectDeep(obj, mapper);
    }
  }
});

//Return a collection of objects that contain only the properties specified in the keys array.
_.mixin({
  mapPick: function (col, keys){
    return _.map(col, function (obj) {
      return _.pick(obj, keys)
    })
  }
});

//Return a collection of objects that contain all properties except for those specified in the keys array.
_.mixin({
  mapOmit: function (col, keys) {
    return _.map(col, function (obj) {
      return _.omit(obj, keys)
    })
  }
});

//Return a short number formatted string (e.g. 1 billion = 1G, 1,000 = 1K)
_.mixin({
  toShortNumberFormat: function (num, digits) {

    if (!_.isNumber(num))
      return "0";

    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9, symbol: "G" },
      { value: 1E6, symbol: "M" },
      { value: 1E3, symbol: "k" }
    ];
    var regx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;

    for (let i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(regx, "$1") + si[i].symbol;
      }
    }
    return num.toFixed(digits).replace(regx, "$1");
  }
});

//Return an object that contains the url query parameters as properties (all lower case).
_.mixin({
  getUrlQueryObject: function () {

    var queryObject = {};

    var query = window.location.search || "";

    if (query.length <= 1)
      return queryObject;

    //Split the hash into individual parts
    var parts = _.split(query.substr(1), "&");

    //Loop through each part and add a name/value pair (property) to the object.
    _.forEach(parts, function (part) {

      var indx = _.indexOf(part, "=");
      var propName = part.substr(0, indx);
      var value = indx < part.length ? decodeURIComponent(part.substr(indx + 1)) : "";

      //Property names are all lowercase
      queryObject[propName.toLowerCase()] = value;
    });

    return queryObject;
  }
});

//Output a url querystring based on properties from the passed in object.
_.mixin({
  getUrlQueryFromObject: function (paramsObject) {

    var query = "";

    //Make sure all property names are lowercase
    var newParamsObject = _.mapKeys(paramsObject, function (val, key) {
      return key.toLowerCase();
    })

    //Build the hash string from our object
    _.forEach(_.keys(newParamsObject), function (key) {

      var value = newParamsObject[key];

      if (_.isUndefined(value) || _.isNull(value))
        value = "";

      var delim = query === "" ? "?" : "&";
      query += delim + key + "=" + encodeURIComponent(value);
    });

    return query;
  }
});

//Encode a string for URL's
_.mixin({
	urlEncode: function (stringValue) {
		//return encodeURIComponent(stringValue).replace(/'/g, "%27").replace(/"/g, "%22");
		return encodeURIComponent(stringValue).replace(/'/g, "''").replace(/"/g, "%22");
	}
});

//Decode a URL string
_.mixin({
	urlDecode: function (stringValue) {
		return decodeURIComponent(stringValue.replace(/\+/g, " "));
	}
});